import { RECORD_TYPE, recordTypeList } from '@Utils/choiceListMapping';
import { AssetSchema } from '@innovyze/lib_asset_schema';

// This is the configuration for pipe and wwPipe before adding the new asset types
const defaulRecordSettings: {
	[systemType: string]: { [assetType: string]: RECORD_TYPE[] } | true;
} = {
	SanitarySewer: true,
	WaterDistribution: {
		pipe: [
			RECORD_TYPE.ASSET_ATTRIBUTES,
			RECORD_TYPE.RISK,
			RECORD_TYPE.USER_DEFINED_FIELDS,
			RECORD_TYPE.TASK,
			RECORD_TYPE.EVENT,
			RECORD_TYPE.ACTION,
		],
	},
};

export const getMigratedRecordsFromFlag = (flag: string): RECORD_TYPE[] => {
	const recordTypes = flag.split(',').map(type => type.trim());
	return recordTypes
		.map(type => RECORD_TYPE[type as keyof typeof RECORD_TYPE])
		.filter(Boolean);
};

export const getAssetTypeRecordTypeOptions = (
	schema: AssetSchema,
	migratedRecords: RECORD_TYPE[],
): Set<RECORD_TYPE> => {
	let enabledRecordTypeOptions: RECORD_TYPE[] = [];

	const recordTypeOptions = defaulRecordSettings[schema.systemType.id];

	if (recordTypeOptions === true) {
		enabledRecordTypeOptions = enabledRecordTypeOptions.concat(
			recordTypeList as RECORD_TYPE[],
		);
	} else if (
		recordTypeOptions &&
		recordTypeOptions[schema.id] !== undefined
	) {
		enabledRecordTypeOptions = enabledRecordTypeOptions.concat(
			recordTypeOptions[schema.id] as RECORD_TYPE[],
		);
	}

	enabledRecordTypeOptions = enabledRecordTypeOptions.concat(migratedRecords);

	return new Set(enabledRecordTypeOptions);
};

export const getRecordTypeOptions = (
	schema: AssetSchema,
	migratedRecords: RECORD_TYPE[],
): RECORD_TYPE[] => {
	const definedRecordTypeOptions = getAssetTypeRecordTypeOptions(
		schema,
		migratedRecords,
	);

	const hasInspectionsCapability = schema.hasCapability('Inspections');
	const hasRiskCapability = schema.hasCapability('Risk');

	const recordTypes = [
		...[hasInspectionsCapability && RECORD_TYPE.INSPECTION],
		...[hasInspectionsCapability && RECORD_TYPE.CONDITION],
		...[hasRiskCapability && RECORD_TYPE.RISK],
		RECORD_TYPE.ASSET_ATTRIBUTES,
		RECORD_TYPE.USER_DEFINED_FIELDS,
		RECORD_TYPE.TASK,
		RECORD_TYPE.EVENT,
		RECORD_TYPE.ACTION,
	].filter(Boolean) as RECORD_TYPE[];

	return recordTypes.filter(type => definedRecordTypeOptions.has(type));
};
